import { useQuery } from '@tanstack/react-query'

import type { KiotVietCodeName } from '@/lib/api/product-api'
import { productApi } from '@/lib/api/product-api'

// Cùng tiền tố với productKeys.all ('products') nên invalidate SP sau khi nối
// cũng làm mới nhãn này. Không import productKeys để picker (dùng ở rất nhiều
// màn) không kéo theo phụ thuộc vào module query SP.
const CODE_NAMES_KEY = ['products', 'kiotviet-code-names'] as const

/** Tên SP KiotViet theo mã cho nhãn "Đang nối" (M-145). Trả Map mã → tên;
 *  tắt (enabled=false) hoặc không có mã thì không gọi API. */
export function useKiotVietCodeNames(codes: string[], enabled: boolean) {
    const sorted = [...new Set(codes.filter(Boolean))].sort()
    return useQuery({
        queryKey: [...CODE_NAMES_KEY, sorted] as const,
        queryFn: async () => {
            const res = await productApi.getKiotVietNames(sorted)
            return new Map<string, KiotVietCodeName>(
                (res.data ?? []).map((n) => [n.code, n]),
            )
        },
        enabled: enabled && sorted.length > 0,
        // Catalog KiotViet ít đổi; BE đã cache 10 phút.
        staleTime: 5 * 60 * 1000,
    })
}
